<template>
	<!--公共头部-->
	<div class="headMainBigbox">
		<div class="head_box warp">
			<!--<a class="head_logo" @click="backIndex"><img src="../../assets/images/logoyst.png" /></a>-->
			<a class="head_logo" @click="backIndex">
				<svg class="icon inconLogo" aria-hidden="true">
					<use xlink:href="#icon-yinshuitong-logo"></use>
				</svg>
			</a>
			<!--<span class="logo_title">开放平台</span>-->
			<!--islogin-begin-->
			<div v-if="userName">
				<div class="login_center">
					<ul>
						<li v-for='(item,index) in items' @click="change(index,item)" :class='{cur:index==number}' @mouseover="listShow(item)" @mouseout="listHide(item)">
							<span v-text="item.name" class="firstMenuList"></span>
							<i :class='iconClass(item)' v-if='item.iconShow' class="msgArrowHeader down"></i>
							<div class="secondMenuBox" v-if="item.isShow">
								<span v-html="itemfirst.secondMenu" v-for='(itemfirst,indexfirst) in item.list' @click="changeSecondList($event,indexfirst,item)" :class='{coloB:indexfirst==secondNumber}'>
								</span>
							</div>
						</li>
					</ul>
				</div>
				<div class="login_msg">
					<span class="header_phone">
					<span class="fl">欢迎您，</span>
					<span class="userName fl" v-text="userName"></span>
					<!--<span class="left_meun_sup" v-text="msgCount"></span>-->
					</span> |
					<a @click="exit">退出</a>
				</div>
			</div>
			<!--end-->
			<div class="logo_right" v-else>
				<span><a class="third_font bgLine" href="#/login">首页</a></span>
				<a class="third_font bgLine" href="http://www.yinshuitong.com" target="_blank">银税通</a>
				<a class="third_font bgLine" href="http://oz.yinshuitong.com" target="_blank">获客平台</a>
				<a class="third_font" href="#/support">帮助与支持</a>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		name: 'comHeader',
		data() {
			return {
				number: sessionStorage.getItem('index') || 1,
				secondNumber: sessionStorage.getItem('secondIndex') || -1,
				init: true, //重新渲染下拉框
				items: [{
						name: "资源中心",
						isShow: false,
						iconShow: true,
						secondListShow: false,
						isHover: true,
						list: [{
								secondMenu: "API介绍"
							},
							{
								secondMenu: "文档中心"
							},
							{
								secondMenu: "沙箱环境"
							}
						]

					},
					{
						name: "开发者中心",
						isShow: false,
						iconShow: false,
						isHover: false
					},
					{
						name: "技术支持",
						isShow: false,
						iconShow: false,
						isHover: false
					}
				]
			}
		},
		computed: {
			...mapState([
				'userName'
			])
		},
		methods: {
			//导航二级菜单切换
			change(index, item) {
				if(index == 0) {
					item.isShow = true;
				} else if(index == 1) {
					this.number = index;
					this.$router.push('/developCenter');
					sessionStorage.setItem('index', this.number)
				} else if(index == 2) {
					this.number = index;
					this.$router.push('/support');
					sessionStorage.setItem('index', this.number)
				}
			},
			//一级菜单切换
			changeSecondList(event, indexfirst, item) {
				event.cancelBubble = true; //因为有两级点击事件，父元素有点击事件，子元素还有点击事件，导致事件冒泡。处理事件冒泡的方法。
				item.isShow = false;
				this.number = 0;
				if(indexfirst == 0) {
					this.$router.push('/resourceCenter');

				} else if(indexfirst == 1) {
					this.$router.push('/documentCenter');

				} else if(indexfirst == 2) {
					this.$router.push('/sboxEverment');

				}
				this.secondNumber = indexfirst;
				sessionStorage.setItem('secondIndex', indexfirst)
				sessionStorage.setItem('index', 0)
				sessionStorage.removeItem('apiIndex')
				sessionStorage.removeItem('docIndex')
			},
			//退出登录
			exit() {
				this.$Message.success("退出登录成功!");
				//				this.isLogin = false;
				sessionStorage.removeItem("userName")
				sessionStorage.removeItem("passWord")
				sessionStorage.removeItem("devId")
				sessionStorage.removeItem("certificate")
				this.$router.push('/login')
			},

			listShow(item) {
				if(item.isHover) {
					item.isShow = true; //菜单的导航  hover的时候出现的效果。
				}
			},
			listHide(item) {
				item.isShow = false;
			},
			iconClass(item) {
				if(item.isShow) {
					return 'msgArrowHeader up';
				} else {
					return 'msgArrowHeader down';
				}

			},
			stateChange() {
				const that = this;
				//				this.userName = sessionStorage.getItem("userName")
				//				this.isLogin = sessionStorage.getItem("userName") ? true : false
				let devParams = {
					"devId": sessionStorage.getItem('devId')
				};
				//资源中心下拉列表缓存控制
				var routeName = this.$route.path;
				if(!(routeName == '/resourceCenter' || routeName == '/documentCenter' || routeName == '/sboxEverment')) {
					this.secondNumber = -1;
					sessionStorage.removeItem('secondIndex')
				}
				//文档中心和API介绍缓存清理
				if(!(routeName == "resourceCenter" || routeName == "documentCenter")) {
					sessionStorage.removeItem('apiIndex')
					sessionStorage.removeItem('docIndex')
				}
				//开发者中心缓存清理
				if(routeName.indexOf('developCenter') == -1) {
					sessionStorage.removeItem('deveIndex')
				}
				//注册缓存清理
				if(routeName.indexOf('register') == -1) {
					sessionStorage.removeItem('OrganizationName')
					sessionStorage.removeItem('email')
					sessionStorage.removeItem('phone')
				}

			},
			backIndex() {
				if(this.userName == "" || this.userName == undefined) {
					this.$router.push('/login');
				}
			}
		},
		watch: {
			// 如果路由有变化，会再次执行该方法
			"$route": "stateChange"
		}
	}
</script>

<style lang="scss">
	.headMainBigbox {
		width: 100%;
		height: 80px;
		box-shadow: 0 2px 3px rgba(72, 81, 102, 0.1);
	}
	
	.logoPicWord {
		font-size: 198px;
		line-height: 74px;
		width: 198px;
		height: 80px;
		display: inline-block;
	}
	
	.headMainBigbox {
		.head_box {
			height: 80px;
			width: 1000px;
			position: relative;
		}
		.inconLogo {
			position: absolute;
			left: 0;
			top: -58px;
		}
		.head_logo {
			margin-top: 20px;
			float: left;
			width: 198px;
		}
		.logo_title {
			height: 40px;
			border-left: 1px solid $border;
			font-size: 30px;
			color: $title;
			font-weight: bold;
			margin-top: 20px;
			float: left;
			margin-left: 12px;
			padding-left: 10px;
			line-height: 36px;
		}
		.logo_right {
			float: right;
			line-height: 80px;
			color: $border;
		}
		.logo_right a {
			padding: 0 12px;
		}
		.logo_right .bgLine {
			/*background: url(../../assets/images/line.png) no-repeat center right;*/
			border-right: 2px solid $title;
			height: 17px;
			display: inline-block;
		}
		.userName {
			margin-right: 5px;
		}
		.fl {
			float: left;
		}
		.login_center {
			padding-left: 20px;
			float: left;
		}
		.login_center li {
			float: left;
			margin-right: 28px;
			padding: 25px 15px 19px 15px;
			position: relative;
			cursor: pointer;
		}
		.firstMenuList {
			color: $link;
			font-size: 20px;
		}
		.login_center li.cur {
			border-bottom: 6px solid $link;
		}
		.login_msg {
			float: right;
			line-height: 80px;
		}
		.header_phone {
			color: $title;
			font-size: 16px;
		}
		.login_msg a {
			color: $link;
		}
		.userName {
			max-width: 130px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.secondMenuBox {
			position: absolute;
			top: 58px;
			left: 0;
			background: #fff;
			z-index: 2;
			width: 100px;
			border-radius: 4px;
			border: 1px solid $headMore;
			box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
			span {
				width: 100%;
				float: left;
				height: 40px;
				line-height: 40px;
				font-size: 14px;
				text-align: center;
			}
			span:hover {
				color: $title;
				cursor: pointer;
				background: $border;
			}
		}
	}
	
	.msgArrowHeader {
		position: absolute;
		width: 10px;
		height: 10px;
		top: 35px;
		right: -6px;
		color: $link;
	}
	
	.coloB {
		color: $link;
	}
	
	.msgArrowHeader.down {
		background: url(../../assets/images/logdown.png) no-repeat;
	}
	
	.msgArrowHeader.up {
		background: url(../../assets/images/logdup.png) no-repeat;
	}
	/**未读消息上面的样式**/
	
	.left_meun_sup {
		display: inline-block;
		position: relative;
		width: 16px;
		height: 16px;
		line-height: 16px;
		color: #fff;
		color: $white;
		background: $circle;
		text-align: center;
		font-size: 12px;
		border-radius: 50%;
		top: -6px;
	}
</style>


// WEBPACK FOOTER //
// src/components/public/ComHeader.vue